import { TRUCK_TYPES, LEGACY_TRUCK_LABEL_TO_KEY } from './constants';

const slug = (s) =>
  String(s || '')
    .trim()
    .toLowerCase()
    .replace(/³/g, '3')
    .replace(/\s+/g, '_');

/** Retourne la clé canonique (ex. grand_fourgon) ou le slug brut si inconnu. */
export const normalizeTruckType = (truckType) => {
  if (truckType == null || truckType === '') return null;
  const t = slug(truckType);
  if (!t) return null;

  if (TRUCK_TYPES[t]) return t;

  const legacyKey = LEGACY_TRUCK_LABEL_TO_KEY[t];
  if (legacyKey && TRUCK_TYPES[legacyKey]) return legacyKey;

  for (const [key, data] of Object.entries(TRUCK_TYPES)) {
    const candidates = [key, ...(data.aliases || [])].map((a) => slug(a));
    if (candidates.includes(t)) return key;
  }

  return t;
};

/** Libellé français pour affichage (résultats, modale…). */
export const getTruckTypeLabel = (truckType) => {
  const key = normalizeTruckType(truckType);
  if (!key) return truckType ? String(truckType) : '—';
  return TRUCK_TYPES[key]?.label || String(truckType);
};

/** Pour l’état du filtre : clé reconnue ou chaîne vide (réponses IA hétérogènes). */
export const toCanonicalTruckKey = (raw) => {
  const k = normalizeTruckType(raw);
  return k && TRUCK_TYPES[k] ? k : '';
};

export const suggestTruckType = (volume) => {
  const v = Number(volume) || 0;
  if (v <= 10) return 'fourgounette';
  if (v <= 18) return 'grand_fourgon';
  if (v <= 28) return 'camion_caisse';
  return 'simple_cabine';
};

export const calculateTotalVolume = (furnitureList) => {
  return furnitureList.reduce((total, item) => {
    const volume = (item.width / 100) * (item.depth / 100) * (item.height / 100);
    return total + volume * (item.quantity || 1);
  }, 0);
};

export const formatVolume = (volume) => {
  return `${volume.toFixed(1)} m³`;
};

export const formatTND = (v) => new Intl.NumberFormat('fr-TN', { style: 'currency', currency: 'TND' }).format(v);

/** Affiche la note (évite N/A pour 0 ; sans avis → tiret). */
export const formatMoverRating = (rating, reviewCount) => {
  const c = Number(reviewCount) || 0;
  if (c === 0) return '—';
  if (rating == null || rating === '') return '—';
  const n = Number(rating);
  if (!Number.isFinite(n)) return '—';
  return n.toFixed(1);
};

export const formatDistanceKm = (km) => {
  if (km == null || !Number.isFinite(km)) return '—';
  if (km >= 100) return String(Math.round(km));
  return km.toFixed(1);
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
